import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import LoadingAnimation from '@/shared/components/LoadingAnimation';
var LoadingContainer = function (_a) {
    var isLoading = _a.isLoading, children = _a.children;
    return isLoading ? _jsx(LoadingAnimation, {}) : _jsx(_Fragment, { children: children });
};
export default LoadingContainer;
